import { render } from "./GalleryDownload.vue?vue&type=template&id=09164507&scoped=true"
import script from "./GalleryDownload.vue?vue&type=script&lang=js"
export * from "./GalleryDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09164507"]])

export default __exports__